import { initializeGeoGirafeCustomStyles, redirectTo, SplashScreen } from '@geogirafe/lib-geoportal/tools';
import MapbsGeoGirafeApp from './bs/base/mapbsgeogirafeapp';

// Redirect to mobile interface if we are on mobile
if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('Android')) {
  const redirectUrl = document.querySelector('meta[name=redirect-url]')?.getAttribute('content');
  if (redirectUrl) {
    redirectTo(redirectUrl);
  }
}

// Display the splash-screen
const splash = new SplashScreen();
splash.begin();

// Manage custom css overrides for core components (if any)
initializeGeoGirafeCustomStyles();

// Create the new GeoGirafe Application
const girafeApp = new MapbsGeoGirafeApp();

// Wait until the application is ready
girafeApp.isReady().then(() => {
  // Remove the splash-screen
  splash.end();
  // Start the onboarding tour
  girafeApp.context.onBoardingManager.start();
});
